// window based tenant setting to reduce amount of necessary build and creating an easier deployment hopefully
export const { apiUrl } = window

// gets the authToken from the provided store
export const authToken = (store) => store.getters.token();
